export default __webpack_public_path__ + "static/media/CNo.47-3.0d4df23d.jpg";